import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDoubleRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 18,
	viewBox: "0 0 27 18",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.24999 2.08062L1.25 15.9194C1.25 16.7579 2.21993 17.2241 2.87469 16.7002L11.5239 9.78086C12.0243 9.38054 12.0243 8.61945 11.5239 8.21913L2.87469 1.29975C2.21992 0.775943 1.24999 1.24212 1.24999 2.08062Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.25 2.08062L15.25 15.9194C15.25 16.7579 16.2199 17.2241 16.8747 16.7002L25.5239 9.78086C26.0243 9.38054 26.0243 8.61945 25.5239 8.21913L16.8747 1.29975C16.2199 0.775943 15.25 1.24212 15.25 2.08062Z",
		fill: "currentColor"
	})]
});
export default SvgArrowDoubleRight;
